export default "__VITE_ASSET__BcAIAe5V__"